import { ButtonGroup, Col, Input, Label } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { OptionOne, OptionTwo } from "../../../../Constant";

export const StaticRadioButtonGroup = () => {
  return (
    <Col xl="4" md="6" sm="12">
      <div className="btn-radio">
        <ButtonGroup>
          <Btn color="primary">
            <div className="radio radio-primary">
              <Input id="radio1" type="radio" name="radio-1" />
              <Label htmlFor="radio1">{OptionOne}</Label>
            </div>
          </Btn>
          <Btn color="primary" active>
            <div className="radio radio-primary">
              <Input id="radio2" type="radio" name="radio-1" />
              <Label htmlFor="radio2">{OptionTwo}</Label>
            </div>
          </Btn>
        </ButtonGroup>
      </div>
    </Col>
  );
};
